import colors from "@/config/colors";
import styles from "./styles.module.scss";

interface Item {
  colorName: keyof typeof colors;
  label: string;
}

interface ColorLegendProps {
  items: Item[];
}

export function ColorLegend({ items }: ColorLegendProps) {
  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item.label} className={styles.item}>
            <span
              className={styles.color}
              style={{ backgroundColor: colors[item.colorName] }}
            />
            <p className={styles.label}>{item.label}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
